import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useRef, useCallback, useEffect } from 'react';

// use 'control' for 'ctrl', 'shift', 'alternate'
function useKeyPress (targetKey) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    keyPressed = _useState2[0],
    setKeyPressed = _useState2[1];
  // State for keeping track of whether key is pressed
  var keyPressedRef = useRef(false);
  // If pressed key is our target key then set to true
  var downHandler = useCallback(function (_ref) {
    var key = _ref.key;
    // eslint-disable-next-line no-console
    // console.log(`------ useKeyPress downHandler ${key} --------`)
    if (key.toLowerCase() === targetKey.toLowerCase()) {
      setKeyPressed(true);
      keyPressedRef.current = true;
    }
  }, [targetKey]);
  // If released key is our target key then set to false
  var upHandler = useCallback(function (_ref2) {
    var key = _ref2.key;
    // eslint-disable-next-line no-console
    // console.log(`------ useKeyPress upHandler ${key} --------`)
    if (key.toLowerCase() === targetKey.toLowerCase()) {
      setKeyPressed(false);
      keyPressedRef.current = false;
    }
  }, [targetKey]);
  // Add event listeners
  useEffect(function () {
    // eslint-disable-next-line no-console
    // console.log('------ add key press listener --------')
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    // Remove event listeners on cleanup
    return function () {
      // eslint-disable-next-line no-console
      // console.log('------ remove key press listener --------')
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [downHandler, upHandler]);
  // eslint-disable-next-line no-console
  // console.log(`------ useKeyPress keyPressed ${keyPressed} --------`)
  return [keyPressed, keyPressedRef];
}

export default useKeyPress;
//# sourceMappingURL=use-key-press.esm.js.map
